import { useState } from "preact/hooks"
import "./styles/modal.css"

export default function({ children, title }) {
    // this.state.visible = this.state.visible || false
    const [visible, setVisible] = useState(false)

    this.show = () => {
        setVisible(true)
    }

    this.hide = () => {
        setVisible(false)
    }

    this.toggle = () => {
        setVisible(prev => !prev)
    }

    return <div class = "tk-modal" style = { {display: visible ? "block" : "none"} }>

        <div class = "tk-modal-content">
            <div class = "tk-modal-header">
                <span class = "tk-modal-close" onClick = { this.hide }>&times;</span>
                <h2>{title}</h2>
            </div>
            <hr/>
            <div class = "tk-modal-body">{children}</div>
        </div>
    </div>
}
